import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { getTermsAndConditions } from "../../utils/urls";
import { FileText } from "lucide-react";

const TermsPage = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["terms-conditions"],
    queryFn: async () => {
      const res = await axios.get(getTermsAndConditions);
      return res.data?.data;
    },
    retry: 1,
  });

  const content = data?.content || data?.terms_and_conditions || data?.text;

  return (
    <div className="page-container flex-1">
      <div className="flex flex-col gap-6 max-w-3xl">
        <div className="pb-4 border-b border-[#E2EBF3] flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#EAF4FF] flex items-center justify-center">
            <FileText size={20} className="text-[#0184FF]" />
          </div>
          <div>
            <p className="text-[1.5rem] font-[600] text-[#0184FF] leading-tight">Terms & Conditions</p>
            <p className="text-[0.8125rem] text-[#64748B]">Please read these terms carefully</p>
          </div>
        </div>

        {isLoading ? (
          <div className="space-y-3 animate-pulse">
            {Array(8).fill(null).map((_, i) => (
              <div key={i} className={`h-4 bg-[#F1F5F9] rounded ${i % 3 === 2 ? "w-3/4" : "w-full"}`} />
            ))}
          </div>
        ) : content ? (
          <div
            className="prose prose-sm max-w-none text-[#475569] leading-relaxed"
            style={{ maxWidth: "65ch" }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="w-16 h-16 rounded-full bg-[#F1F5F9] flex items-center justify-center mb-4">
              <FileText size={28} className="text-[#94A3B8]" />
            </div>
            <p className="text-[0.9375rem] font-semibold text-[#0F172A]">Terms not available</p>
            <p className="text-[0.8125rem] text-[#64748B] mt-1">Please contact support for the latest terms and conditions.</p>
          </div>
        )}

        {data?.last_updated && (
          <p className="text-[0.75rem] text-[#94A3B8] border-t border-[#E2E8F0] pt-4">
            Last updated: {new Date(data.last_updated).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })}
          </p>
        )}
      </div>
    </div>
  );
};

export default TermsPage;
